import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Type } from '@angular/core';
import { ModalService } from '@luggagehero/core';
import { BookingOptionsBaseComponent, ReportIncidentActionBaseComponent } from '@luggagehero/features/bookings';
import { SharedShopsService } from '@luggagehero/shared/services/shops';
import { HowItWorksComponent } from '@luggagehero/web/features/ui';
import { TranslateService } from '@ngx-translate/core';

import {
  CancelBookingActionComponent,
  GoToShopActionComponent,
  ModifyBookingActionComponent,
  ReportIncidentActionComponent,
  SelectPaymentMethodActionComponent,
  ShowReceiptActionComponent,
} from '../booking-actions';

@Component({
  selector: 'lh-booking-options',
  templateUrl: './booking-options.component.html',
  styleUrls: ['./booking-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingOptionsComponent extends BookingOptionsBaseComponent {
  public constructor(
    private modalService: ModalService,
    storageLocationService: SharedShopsService,
    translate: TranslateService,
    cd: ChangeDetectorRef,
  ) {
    super(storageLocationService, translate, cd);
  }

  get cancelBookingActionComponentType(): Type<CancelBookingActionComponent> {
    return CancelBookingActionComponent;
  }

  get goToShopActionComponentType(): Type<GoToShopActionComponent> {
    return GoToShopActionComponent;
  }

  get selectPaymentMethodActionComponentType(): Type<SelectPaymentMethodActionComponent> {
    return SelectPaymentMethodActionComponent;
  }

  get modifyBookingActionComponentType(): Type<ModifyBookingActionComponent> {
    return ModifyBookingActionComponent;
  }

  get showReceiptActionComponentType(): Type<ShowReceiptActionComponent> {
    return ShowReceiptActionComponent;
  }

  get reportIncidentActionComponentType(): Type<ReportIncidentActionBaseComponent> {
    return ReportIncidentActionComponent;
  }

  showHowItWorks(): Promise<void> {
    return void this.modalService.show({ component: HowItWorksComponent });
  }
}
